import React, { useEffect, useState, useContext } from "react";
import { Button, Form, Modal, Row, Col, Spinner } from "react-bootstrap";
import menuList from "../../data/sessionmaster.json";
import "./AddEditRoleMaster.css";
import "react-toastify/dist/ReactToastify.css";
import { getAllRoles, AddNewRole } from "../../services/role-service";
import {
    getCurrentDateTime,
    formatDateInDDMMYYYY,
} from "../../functions/common-functions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import { AuthContext } from "../../contexts/AuthContext";
import { getUsersForRole } from "../../services/user-service";
import { addLogDetails } from "../../services/logger-entry-service";
import { ALERT_PARAMS } from "../../utils/constant.js";

const AddEditRoleMaster = (props) => {
    const MySwal = withReactContent(Swal);
    const context = useContext(AuthContext);
    const userDetails = {
        email: context.userEmail,
        userName: context.userName,
        userId: context.userId,
        role: context.role,
    };

    let action = props.action;
    const menuResult = menuList;
    const [toggleClass, setToggleClass] = useState("activeToggleLabel");
    const [loading, setLoading] = useState(false);

    const [roleObj, setRoleObj] = useState(
        action === "Edit" || action === "View"
            ? props.rowdata
            : {
                RoleDescription: "",
                RoleCode: "",
                DeleteIndication: "Active"
            }
    );
    useEffect(() => {
        if (action === "View" || action === "Edit") {
            if (props.rowdata.DeleteIndication === "Active") {
                setToggleClass("activeToggleLabel")
            }
            else {
                setToggleClass("inactiveToggleLabel")
            }
        }
    }, []);
    const [menuJson, setmenuJson] = useState(
        action === "View" || action === "Edit"
            ? (Array.isArray(props.rowdata.AuthorizedSessions) && typeof props.rowdata.AuthorizedSessions[0] === 'string'
                ? props.rowdata.AuthorizedSessions.map(sessionName => ({ SessionName: sessionName, Display: true, Add: true, Modify: true, Delete: true, Export: true }))
                : props.rowdata.AuthorizedSessions || [])
            : []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (action == "View") {
            props.onHide();
        }
        else {
            setLoading(true);
            const result1 = await getAllRoles();
            console.log("result1", result1)
            if (result1.length > 0 && result1.filter((item) => (action === "Add" || (action === "Edit" && item.RoleCode.toLowerCase() !== roleObj.RoleCode.toLowerCase())) && item.RoleCode.toLowerCase() === roleObj.RoleCode.toLowerCase()).length > 0) {
                setLoading(false);
                MySwal.fire({
                    text: "Role Code already exists.",
                    imageUrl: errorImage,
                    customClass: "swal-success",
                });
                return;
            }
            if (menuJson.length === 0) {
                setLoading(false);
                MySwal.fire({
                    text: "Please select at least one checkbox",
                    imageUrl: errorImage,
                    customClass: "swal-success",
                });
                return;
            }

            setLoading(false);
            let confirmBoxText = "";
            let confirmButtonText = "";
            if (action === "Add") {
                confirmBoxText = "Are you sure, do you want to add new role?";
                confirmButtonText = "Add";
            }
            else if (action == "Edit") {
                confirmBoxText = "Are you sure, do you want to update role?";
                confirmButtonText = "Update";
            }

            MySwal.fire({
                text: confirmBoxText,
                confirmButtonText: confirmButtonText,
                title: action + " Role",
                ...ALERT_PARAMS,
            }).then(async (result2) => {
                if (result2.isConfirmed) {
                    setLoading(true);
                    if (action === "Add") {
                        let todayDate = getCurrentDateTime("-");
                        roleObj.CreatedBy = userDetails.userId;
                        roleObj.CreatedByName = userDetails.userName;
                        roleObj.CreatedOn = todayDate;
                        roleObj.ModifiedBy = userDetails.userId;
                        roleObj.ModifiedByName = userDetails.userName;
                        roleObj.ModifiedOn = todayDate;
                        roleObj.AuthorizedSessions = menuJson.map(
                            (item) => item.SessionName
                        );
                        roleObj.PK = "RoleMaster";
                        roleObj.SK = "RoleCode#" + roleObj.RoleCode;
                    } else if (action == "Edit") {
                        let todayDate = getCurrentDateTime("-");
                        roleObj.AuthorizedSessions = menuJson.map(
                            (item) => item.SessionName
                        );
                        roleObj.ModifiedBy = userDetails.userId;
                        roleObj.ModifiedByName = userDetails.userName;
                        roleObj.ModifiedOn = todayDate;
                    }
                    let result = await AddNewRole(roleObj);
                    if (result?.status) {
                        let successMsg = result.message;
                        if (action == "Edit") {
                            successMsg = "Role is updated successfully";
                        }
                        //For logger details
                        let tempUnique = "SK#" + roleObj.SK;
                        await addLogDetails(
                            roleObj,
                            action,
                            tempUnique,
                            "RoleMasterLog",
                            userDetails,
                            "Master"
                        );
                        setLoading(false);
                        MySwal.fire({
                            text: successMsg,
                            imageUrl: successImage,
                            customClass: "swal-success",
                            didClose: () => {
                                props.setreload(!props.reload);
                                props.onHide();
                                if (roleObj.RoleCode === userDetails.role) {
                                    window.location.reload();
                                }
                            },
                        });
                    } else {
                        setLoading(false);
                        MySwal.fire({
                            text: "Unable to Process Request",
                            imageUrl: errorImage,
                            customClass: "swal-success",
                        });
                    }
                }
            });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log("Role e.target ==> ", e.target);
        console.log("name, value ==> ", name, value);

        if (name === "RoleCode") {
            const alphanumericRegex = /^[a-zA-Z0-9]*$/;
            if (!alphanumericRegex.test(value)) {
                return;
            }
        }
        if (name === "RoleDescription") {
            const alphanumericRegex = /^[a-zA-Z0-9 ]*$/;
            if (!alphanumericRegex.test(value)) {
                return;
            }
        }
        console.log(name, value)
        setRoleObj((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSelectAllSessions = (e) => {
        let flag = e.target.checked;
        console.log("handleSelectAllSessions e.target ==> ", e.target);
        if (flag) {
            const allSessions = menuResult.map(data => ({
                SessionName: data.SubMenu === '' ? data.ParentMenu : data.SubMenu,
                Display: true,
                Add: true,
                Modify: true,
                Delete: true,
                Export: true
            }));
            setmenuJson(allSessions);
        } else {
            setmenuJson([]);
        }
        console.log("End of handleSelectAllSessions");
    }

    const handleChangeSelectAll = (e, menu, menuType, parentMenu, i) => {
        let flag = e.target.checked;
        let tempMenuJson = [];
        tempMenuJson = Object.assign([], menuJson);
        let resultMaster = {
            SessionName: menu,
            Display: flag,
            Add: flag,
            Modify: flag,
            Delete: flag,
            Export: flag,
        };
        let result = Object.assign({}, resultMaster);

        const Index = tempMenuJson.findIndex((element) => element.SessionName === menu);
        if (Index !== -1) {
            tempMenuJson.splice(Index, 1);
        }
        if (flag) {
            tempMenuJson.push(result);
        }

        if (menuType === "ParentMenu") {
            let submenus = menuResult.filter(e => e.ParentMenu === menu && e.SubMenu !== "");
            submenus.forEach(element => {
                const SubIndex = tempMenuJson.findIndex((data) => data.SessionName === element.SubMenu);
                let subMenuExistcheck = Object.assign({}, result);
                if (SubIndex !== -1) {
                    tempMenuJson.splice(SubIndex, 1);
                }
                subMenuExistcheck["SessionName"] = element.SubMenu;
                if (flag) {
                    tempMenuJson.push(subMenuExistcheck);
                }
            });
        } else if (menuType === "SubMenu") {
            if (flag) {
                // Check if parent exists, if not add it
                const parentIndex = tempMenuJson.findIndex((element) => element.SessionName === parentMenu);
                if (parentIndex === -1) {
                    let parentResult = { SessionName: parentMenu, Display: true, Add: true, Modify: true, Delete: true, Export: true };
                    tempMenuJson.push(parentResult);
                }
            } else {
                // Submenu unchecked, remove parent menu
                const parentIndex = tempMenuJson.findIndex((element) => element.SessionName === parentMenu);
                if (parentIndex !== -1) {
                    tempMenuJson.splice(parentIndex, 1);
                }
            }

            // Check if all submenus are checked, then add parent, otherwise remove parent
            let submenus = menuResult.filter(e => e.ParentMenu === parentMenu && e.SubMenu !== "");
            let checkedSubmenus = submenus.filter(submenu =>
                tempMenuJson.some(menuItem => menuItem.SessionName === submenu.SubMenu)
            );

            const parentIndex = tempMenuJson.findIndex((element) => element.SessionName === parentMenu);
            if (checkedSubmenus.length === submenus.length && submenus.length > 0) {
                // All submenus checked, ensure parent is checked
                if (parentIndex === -1) {
                    let parentResult = { SessionName: parentMenu, Display: true, Add: true, Modify: true, Delete: true, Export: true };
                    tempMenuJson.push(parentResult);
                }
            } else {
                // Not all submenus checked, remove parent
                if (parentIndex !== -1) {
                    tempMenuJson.splice(parentIndex, 1);
                }
            }
        }

        console.log("tempMenuJson", tempMenuJson)
        setmenuJson(tempMenuJson);
    }


    const handleCancel = () => {
        props.onHide();
    }

    const handleReset = () => {
        if (action === "Add") {
            setRoleObj((prevState) => ({
                ...prevState,
                RoleCode: "",
                RoleDescription: "",
                DeleteIndication: "Active",
            }));
            setmenuJson([]);
            setToggleClass("activeToggleLabel");
        }
    };

    const handleSwitchChange = (e) => {
        if (e.target.checked) {
            setToggleClass("activeToggleLabel");
        } else {
            setToggleClass("inactiveToggleLabel");
        }

        setRoleObj((prevState) => ({
            ...prevState,
            DeleteIndication: e.target.checked ? "Active" : "Inactive",
        }));
    };

    return (
        <>
            {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
            <Modal centered
                {...props}
                size="lg"
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modalTitle">
                        {action} Role
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        id="rolemaster"
                        name="rolemaster"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                    >
                        <Row >
                            <Col md={4} sm={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="RoleCode"
                                        type="text"
                                        name="RoleCode"
                                        maxLength="20"
                                        placeholder=" "
                                        required
                                        value={roleObj.RoleCode}
                                        onChange={handleChange}
                                        readOnly={action === "View" || action === "Edit" ? true : false}
                                    />
                                    <Form.Label className="frm-label" for="RoleCode">Role Code</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col md={4} sm={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="RoleDescription"
                                        type="text"
                                        name="RoleDescription"
                                        maxLength="50"
                                        placeholder=" "
                                        required
                                        value={roleObj.RoleDescription}
                                        onChange={handleChange}
                                        readOnly={action === "View" ? true : false} />
                                    <Form.Label className="frm-label" for="RoleDescription">Role Description</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col md={4} sm={12}>
                                <Row>
                                    {/* <Form.Group className="form-switch-input"> */}
                                    <Col>
                                        <Form.Label className="fieldLabel">Status</Form.Label>
                                        {/* <Col> <div class="g-input"></div>  <label style={{ fontSize: "14px", padding: "10px", color: "#6F6F70", fontWeight: "bold" }} >Status </label></Col> */}
                                    </Col>
                                    <Col>
                                        <Form.Switch className={"semiBoldToggleButton " + toggleClass}
                                            label={roleObj.DeleteIndication === "Active" ? "Active" : "Inactive"}
                                            name="DeleteIndication"
                                            // style={{ padding: "10px",color: "#428F30" }}
                                            checked={roleObj.DeleteIndication === "Active" ? true : false}
                                            onChange={(e) => {
                                                handleSwitchChange(e);
                                            }}
                                            disabled={action === "View" ? true : false}
                                        />
                                    </Col>
                                    {/* </Form.Group> */}
                                </Row>
                            </Col>

                        </Row>
                        <Row>
                            <span className="sectionTitle" >Session Access <span className="italicFont">( Mandatory )</span></span>
                        </Row>
                        <div className="tabledataformat d-none d-md-block d-lg-block">
                            <Row className="text-size" >
                                <Col xs={8} className="menuheadCol" >Session</Col>
                                <Col xs={4}>
                                    Access
                                    <Form.Check
                                        type="checkbox"
                                        label="Select All"
                                        checked={menuJson.length === menuResult.length}
                                        onChange={handleSelectAllSessions}
                                        disabled={action === "View"}
                                        style={{ display: 'inline-block', marginLeft: '22px' }}
                                    />
                                </Col>
                            </Row>
                            {
                                menuResult?.map((data, index) => {
                                    return (
                                        <Row className={data.SubMenu === '' ? "parentMenuRow" : "subMenuRow"} >
                                            <Col xs={8} className="menuheadCol">
                                                {data.SubMenu === '' ? data.ParentMenu : data.SubMenu}
                                            </Col>
                                            <Col xs={4}>
                                                <Form.Check
                                                    type="checkbox"
                                                    id="Access"
                                                    name={data.ParentMenu + index}
                                                    checked={
                                                        (menuJson.filter(e => e.SessionName === (data.SubMenu === '' ? data.ParentMenu : data.SubMenu)).length <= 0) ? false : menuJson.filter(e => e.SessionName === (data.SubMenu === '' ? data.ParentMenu : data.SubMenu))
                                                    }
                                                    onChange={(e) => {
                                                        handleChangeSelectAll(e, data.SubMenu === '' ? data.ParentMenu : data.SubMenu, data.SubMenu === '' ? "ParentMenu" : "SubMenu", data.ParentMenu, index);
                                                    }}
                                                />
                                            </Col>
                                        </Row>

                                    )
                                })

                            }
                        </div>
                        <br />
                        <div className="tabledataformat">
                            <Row className="remark">
                                <Col md={12}>
                                    <span ><b>Remark</b></span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <span>List of all sessions with checkbox for selection </span>
                                </Col>
                            </Row>
                            <br />
                            <Row >
                                <Col md={9} xs={6}><Row>
                                    <Col md={3} xs={12}>{action === "View" || action === "Edit" ? null :
                                        <Button className="semiBoldToggleButton cancelBtn"
                                            variant="outline-success"
                                            //onClick={props.onHide}
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </Button>
                                    }
                                    </Col>
                                    <Col xs={12} md={6}>{action === "View" || action === "Edit" ? <></> :
                                        <Button className="resetBtn semiBoldToggleButton"
                                            variant="link"
                                            onClick={handleReset}
                                        >Reset Fields
                                        </Button>
                                    }
                                    </Col>
                                </Row>
                                </Col>
                                <Col md={3} xs={6}>
                                    <Button variant="success" className="btn-add-color semiBoldToggleButton rightAlignedButton" type="submit">
                                        {action === "Edit" ? "Update" : "Add"}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddEditRoleMaster;
